module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j0qJc"))).then(() => module.bundle.root('hEqeo'));